/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'performance-tracing',
  title: 'Trace slow requests',
  category: 'Tracing',
  summary:
    'Record what sampled Django requests actually did — every SQL query and its timing, custom spans and optionally which of your functions ran — under Project → Tracing.',
  keywords: ['tracing', 'performance', 'slow requests', 'SQL queries', 'spans', 'traces_sample_rate', 'profiling', 'Django'],
};

export const loadComponent = () => import('./performance-tracing.component').then((m) => m.PerformanceTracingArticleComponent);
